import { CHANGE_SCREEN_TYPE } from './action-types'
import * as SCREEN_TYPES from './screen-types'

export default (
  state = {},
  { type, payload },
) => {
  switch (type) {
    case CHANGE_SCREEN_TYPE:
      const isMobile = payload === SCREEN_TYPES.MOBILE,
        isTablet = payload === SCREEN_TYPES.TABLET,
        isDesktop = payload === SCREEN_TYPES.DESKTOP

      return Object.values(SCREEN_TYPES).includes(payload)
        ? { ...state, screenType: payload, isMobile, isTablet, isDesktop }
        : state
    default:
      return state
  }
}
